var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "sui-container",
        [
          _c("sui-grid", { staticClass: "ui right aligned grid" }, [
            _c(
              "div",
              { staticClass: "center aligned two column row" },
              [
                _c("div", { staticClass: "center aligned two column row" }, [
                  _c(
                    "div",
                    { staticClass: "right floated left aligned column" },
                    [
                      _c("h2", { staticClass: "ui left floated header" }, [
                        _vm._v("Users"),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "sui-grid-column",
                  [
                    _c("sui-button", {
                      attrs: {
                        basic: "",
                        color: "blue",
                        size: "mini",
                        content: "New User",
                      },
                      on: { click: _vm.handleCreate },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 6 } },
                    [
                      _c("sui-input", {
                        attrs: {
                          placeholder: "Enter user name to search list...",
                          icon: "search",
                          "icon-position": "left",
                          fluid: "",
                        },
                        model: {
                          value: _vm.searchPhrase,
                          callback: function ($$v) {
                            _vm.searchPhrase = $$v
                          },
                          expression: "searchPhrase",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("sui-grid-column", { attrs: { width: 10 } }, [
                    _c(
                      "div",
                      { staticClass: "table-filter" },
                      [
                        _c("sui-dropdown", {
                          attrs: {
                            placeholder: "Filter",
                            text: "Filter",
                            selection: "",
                            options: _vm.userStatusFilterOptions,
                          },
                          model: {
                            value: _vm.userStatusFilterVal,
                            callback: function ($$v) {
                              _vm.userStatusFilterVal = $$v
                            },
                            expression: "userStatusFilterVal",
                          },
                        }),
                        _vm.authUser.profile.is_super_admin
                          ? _c("sui-dropdown", {
                              attrs: {
                                placeholder: "Firm",
                                text: "Firm",
                                selection: "",
                                floating: "",
                                options: _vm.firms,
                                disabled: _vm.disableFirmMenu,
                              },
                              model: {
                                value: _vm.firmFilterVal,
                                callback: function ($$v) {
                                  _vm.firmFilterVal = $$v
                                },
                                expression: "firmFilterVal",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("List", {
            attrs: { users: _vm.users, searchPhrase: _vm.searchPhrase },
            on: { handleEdit: _vm.handleEdit },
          }),
          _c("UserModal", {
            attrs: {
              "is-open": _vm.isOpen,
              "modal-action": _vm.modalAction,
              "toggle-modal": _vm.toggleModal,
              "get-users": _vm.getUserList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }